<ngx-spinner></ngx-spinner>
<mat-drawer-container>
  <mat-drawer #drawer class="bg-col1" mode="over" [opened]="open" (openedChange)="onOpenedChange($event)" *ngIf="!isHideDrawer">
    <app-top-menu (sendDataToParent)="eventFromChild($event)"></app-top-menu>
  </mat-drawer>

  <div class="wrapper h-100">
    <app-header (sendDataToParent)="eventFromChild($event)"></app-header>
    <div class="pageContainer">
      <div class="pageContainerInner">
        <router-outlet></router-outlet>
      </div>
    </div>
    <app-footer></app-footer>

    <div *ngIf="!userClosedCookie" class="privacyPolicyBar">
      <div class="inner">
        By continuing to browse the site, you're agreeing to our use of cookies. Learn more in our <a
          href="https://www.thelabrador.co.uk/privacy-notice" class="elink" target="_blank">privacy policy</a>.
        <span title="Click to hide this bar" class="closeBar" (click)="closePrivacyPolicy()">&times;</span>
      </div>
    </div>
  </div>
</mat-drawer-container>